function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Google = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fill: "#4285F4",
    d: "M37.502 20.389c0-1.44-.12-2.49-.377-3.578H20.359v6.494H30.2c-.198 1.614-1.27 4.045-3.65 5.678l-.034.218 5.301 4.024.367.036c3.373-3.053 5.318-7.545 5.318-12.872Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#34A853",
    d: "M20.358 37.5c4.821 0 8.869-1.556 11.825-4.239l-5.635-4.278c-1.508 1.03-3.532 1.75-6.19 1.75a10.73 10.73 0 0 1-10.159-7.272l-.21.017-5.512 4.181-.072.196c2.937 5.717 8.969 9.645 15.953 9.645Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FBBC05",
    d: "M10.2 23.461A10.58 10.58 0 0 1 9.605 20c0-1.206.218-2.372.575-3.461l-.01-.232-5.581-4.248-.183.085A17.232 17.232 0 0 0 2.502 20c0 2.82.694 5.483 1.904 7.855l5.794-4.394Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#EB4335",
    d: "M20.358 9.267c3.353 0 5.615 1.42 6.905 2.605l5.04-4.822C29.206 4.23 25.178 2.5 20.357 2.5c-6.984 0-13.016 3.928-15.953 9.644l5.774 4.395c1.449-4.22 5.457-7.272 10.179-7.272Z"
  })]
}));
//# sourceMappingURL=Google.js.map